import {
  ref,
} from "vue";

import PuxEmpty from "../PuxEmpty/PuxEmpty.vue";

export const tablePluginOptions = ref({
  propsDefault: {
    canSaveFilters: true,
    limitsPerPage: ["10", "25", "50", "100"],
    limitStart: undefined,
    urlUpdate: true,
  },
  global: {
    isAllRowsSelected: undefined,
    project: "",
    timeCookiesFilters: 0.0417, // eine Stunde 1 / 24 = 0.041666
  },
});

const PLUGIN_DEFAULT = {
  install,
  Components: {
    // Proandi
    CsvDownload: PuxEmpty,
    PuxTableMultipleActionsWorkflowfolgen: PuxEmpty,
    PuxTableRowDefaultSlot: PuxEmpty,
    PuxTemplateDownload: PuxEmpty,
    // PVP
    CsvExportModal: PuxEmpty,
  },
  UserAPI: () => {
    return {};
  },
  PermissionAPI: () => {
    return {};
  },
  SyConfigAPI: () => {
    const getSyConfigsValue = (name, defaultValue) => {
      return defaultValue;
    };
    return {
      getSyConfigsValue,
    };
  },
  LayoutAPI: () => {
    return {};
  },
  // PVP
  CsvExportModalAPI: () => {
    return {};
  },
};

function install(app, {
  propsDefault = {},
  global = {},
  components = {},
  userApi,
  permissionAPI,
  syConfigAPI,
  layoutAPI,
  csvExportModalAPI,
} = {}) {
  tablePluginOptions.value.propsDefault = {
    ...tablePluginOptions.value.propsDefault,
    ...propsDefault,
  };
  tablePluginOptions.value.global = {
    ...tablePluginOptions.value.global,
    ...global,
  };
  PLUGIN_DEFAULT.Components = {
    ...PLUGIN_DEFAULT.Components,
    ...components,
  };
  if (userApi) {
    PLUGIN_DEFAULT.UserAPI = userApi;
  }
  if (permissionAPI) {
    PLUGIN_DEFAULT.PermissionAPI = permissionAPI;
  }
  if (syConfigAPI) {
    PLUGIN_DEFAULT.SyConfigAPI = syConfigAPI;
  }
  if (layoutAPI) {
    PLUGIN_DEFAULT.LayoutAPI = layoutAPI;
  }
  if (csvExportModalAPI) {
    PLUGIN_DEFAULT.CsvExportModalAPI = csvExportModalAPI;
  }
}

export default PLUGIN_DEFAULT;
